import { Loader } from "../../shared-components/loader/Loader"

export const SigningIn = () => {
    return <Loader shape='rect' label='Signing in...' fullPage />
}